import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import {
  SpecialRequirementsTypeKey,
  SpecialRequirementsTypeLabel,
} from '@/utils/enum'

export default /*#__PURE__*/_defineComponent({
  __name: 'WheelsTripRequirements',
  props: {
    ada: { type: Boolean },
    adaChanged: { type: Boolean },
    spab: { type: Boolean },
    spabChanged: { type: Boolean },
    vehicleNeededEntireTrip: { type: Boolean },
    vehicleNeededEntireTripChanged: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  ada: boolean
  adaChanged?: boolean
  spab: boolean
  spabChanged?: boolean
  vehicleNeededEntireTrip: boolean
  vehicleNeededEntireTripChanged?: boolean
};



const selectedRequirements = computed(() => {
  return [
    {
      icon: 'busAlert',
      title: SpecialRequirementsTypeLabel.VehicleNeededEntireTrip,
      condition: props.vehicleNeededEntireTrip,
      key: SpecialRequirementsTypeKey.VehicleNeededEntireTrip,
      modified: props.vehicleNeededEntireTripChanged,
    },
    {
      icon: 'accessible',
      title: SpecialRequirementsTypeLabel.ADA,
      condition: props.ada,
      key: SpecialRequirementsTypeKey.ADA,
      modified: props.adaChanged,
    },
    {
      icon: 'school',
      title: SpecialRequirementsTypeLabel.SPAB,
      condition: props.spab,
      key: SpecialRequirementsTypeKey.SPAB,
      modified: props.spabChanged,
    },
  ].filter(({ condition }) => condition)
})

return { __sfc: true,props, selectedRequirements, SpecialRequirementsTypeKey }
}

})